// John Eldhose 20231121
import { RestfulUpload } from './Restful';

export async function uploadFile(url, file) {
  const fd = new FormData();
  fd.append('uploadFile', file, file.name);
  const uf = await RestfulUpload(url, fd, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return uf;
}



// WEBPACK FOOTER //
// ./src/Api/uploadFile.js